import React from 'react';
import '../../styles/Auth.css';

export type AuthPageVariant = 'login' | 'register' | 'forgot-password';

export interface AuthPageTemplateProps {
  variant: AuthPageVariant;
  /** Optional illustration on the left panel (login/register). */
  leftImageSrc?: string;
  leftImageAlt?: string;
  /** Custom left panel content (e.g. forgot-password hero). */
  leftPanel?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const variantClass: Record<AuthPageVariant, string> = {
  login: 'login-page',
  register: 'register-page',
  'forgot-password': 'forgot-password-page',
};

const layoutClass: Record<AuthPageVariant, string> = {
  login: 'login-layout',
  register: 'register-layout',
  'forgot-password': 'forgot-password-layout',
};

const leftPanelClass: Record<AuthPageVariant, string> = {
  login: 'login-left-panel',
  register: 'register-left-panel',
  'forgot-password': 'forgot-password-left-panel',
};

const leftImageClass: Record<AuthPageVariant, string> = {
  login: 'login-left-image',
  register: 'register-left-image',
  'forgot-password': 'forgot-password-left-image',
};

const AuthPageTemplate: React.FC<AuthPageTemplateProps> = ({
  variant,
  leftImageSrc,
  leftImageAlt,
  leftPanel,
  children,
  className = '',
  style,
}) => {
  const pageClass = variantClass[variant];
  const layout = layoutClass[variant];
  const leftClass = leftPanelClass[variant];
  const imageClass = leftImageClass[variant];

  return (
    <div
      className={`auth-container ${pageClass} ${className}`.trim()}
      data-auth-template={variant}
      style={style}
    >
      <div className={layout}>
        <div className={leftClass} aria-hidden={leftPanel ? undefined : true}>
          {leftPanel}
          {leftImageSrc && (
            <img src={leftImageSrc} alt={leftImageAlt ?? ''} className={imageClass} />
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default AuthPageTemplate;
